import { tickerNews } from '@/mocks/homeContent';

export default function Ticker() {
  const row = [...tickerNews, ...tickerNews];
  return (
    <div id="ticker" className="overflow-hidden bg-primary-500">
      <div className="mx-auto flex max-w-[1240px] items-center px-4 md:px-6">
        <div className="relative z-10 flex shrink-0 items-center gap-2 bg-primary-500 pr-4">
          <span className="flex h-5 items-center gap-1 rounded-sm bg-background-50 px-1.5 font-label text-[12px] tracking-wide text-primary-600">
            全网更新
          </span>
          <span className="relative flex h-2 w-2">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-accent-300 opacity-75" />
            <span className="relative inline-flex h-2 w-2 rounded-full bg-accent-300" />
          </span>
        </div>
        <div className="relative flex-1 overflow-hidden py-2.5" aria-hidden="true">
          <div className="animate-ticker flex w-max items-center gap-8 whitespace-nowrap">
            {row.map((n, i) => (
              <a
                key={i}
                href="#top"
                onClick={(e) => e.preventDefault()}
                className="flex items-center gap-2 text-sm text-background-50/95 transition hover:text-background-50"
              >
                <i className="ri-arrow-right-s-line flex h-4 w-4 items-center justify-center text-accent-300" />
                {n}
              </a>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}